import { executeM365AppsConfigDataFlow } from './executeM365AppsConfigDataFlow';
export var m365AppsConfigOptions = {
    key: 'M365AppsData',
    getServerGeneratedConfig: function (context) {
        return executeM365AppsConfigDataFlow(context);
    },
};
//# sourceMappingURL=m365AppsConfigOptions.js.map